// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,

		promo_product: boostPFSThemeConfig.custom.promo_product,
		promo_collection: boostPFSThemeConfig.custom.promo_collection,
		promo_image: boostPFSThemeConfig.custom.promo_image,
		promo_position: boostPFSThemeConfig.custom.promo_position,
		product_inquire: boostPFSThemeConfig.custom.product_inquire,
		promo_image_mob: boostPFSThemeConfig.custom.promo_image_mob,
		promo_position_mob: boostPFSThemeConfig.custom.promo_position_mob,

		// Optional
		loadProductFirst: false,
		styleScrollToTop: 'style2',
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		showPlaceholderProductList: true
	},
};

(function() {
	BoostPFS.inject(this);

	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)

		

		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add a specific class for grid item
		var itemGridWidthClass = '';
		var imageSize = '600x600';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemGridWidthClass = 'medium-up--one-half';
				imageSize = '540x600';
				break;
			case 3:
				itemGridWidthClass = 'small--one-half medium-up--one-third';
				imageSize = '345x550';
				break;
			case 4:
				itemGridWidthClass = 'small--one-half medium-up--one-quarter';
				imageSize = '250x';
				break;
			case 5:
				itemGridWidthClass = 'small--one-half medium-up--one-fifth';
				imageSize = '195x';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		// Add fullWidth class
		// var itemFullWidthClass = boostPFSFilterConfig.general.promo_product ? boostPFSTemplate.fullWidthClass : '';
		var itemFullWidthClass = '';
		itemHtml = itemHtml.replace(/{{itemFullWidthClass}}/g, itemFullWidthClass);

		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;

		// Build Image style
		var imageStyle = buildImageStyle(data);
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

		// Add Images
		var aspect_ratio = '';
		var itemImagesHtml = '';

		function testJSON(text){
			if (typeof text!=="string"){
					return false;
			}
			try{
					var json = JSON.parse(text);
					return (typeof json === 'object');
			}
			catch (error){
					return false;
			}
		}
		
		if (data.metafields.length > 0 && testJSON(data.metafields[0].value)) {
			itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper grid-view-item__image-wrapper--metafield js">';
			//console.log(data.metafields);
			//console.log(data.metafields[0].value);
			//console.log(data.metafields[1].value);
				var gallery_color_labels = JSON.parse(data.metafields[0].value);
				var gallery_color_src ={};
			if (typeof(data.metafields[1]) !== 'undefined') {
					gallery_color_src = JSON.parse(data.metafields[1].value);
				

					//console.log(gallery_color_labels);
					//console.log(gallery_color_src);
				for (var i = 0; i < gallery_color_labels.length; i++) {
					//console.log(gallery_color_labels[i]);

					if(i == 0) {
						itemImagesHtml += '<div class="grid-view-item__slider-wrapper grid-view-item__slider-wrapper--metafield active" data-color="'+ gallery_color_labels[i] +'">';
					} else {
						itemImagesHtml += '<div class="grid-view-item__slider-wrapper grid-view-item__slider-wrapper--metafield" data-color="'+ gallery_color_labels[i] +'">';
					}

					for (var j = 0; j < gallery_color_src[i].length; j++) {
						//console.log(gallery_color_src[i][j].src);

						itemImagesHtml += '<div class="grid-view-item__picture">';
						itemImagesHtml += '<img id="' + imgId + '" ' +
							'class="grid-view-item__image 333 lazyload" ' +
							'src="' + gallery_color_src[i][j].src + '" ' +
							'data-src="' + gallery_color_src[i][j].src + '" ' +
							'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
							'data-sizes="auto" ' +
							'alt="{{itemTitle}}">';
						itemImagesHtml += '</div>';
					}
					itemImagesHtml += '</div>';
				}
			}
	
			itemImagesHtml += '</div>';
		} else {

			itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
			itemImagesHtml += '<div class="grid-view-item__slider-wrapper" style="/*padding-top:';
			if (images.length > 0) {
				aspect_ratio = images[0]['width'] / images[0]['height'];
				itemImagesHtml += 1 / aspect_ratio * 100;
			} else {
				itemImagesHtml += 100;
			}
			var options_with_values = data.options_with_values;
		/*	for (var j = 0; j < options_with_values.length; j++) {
				if (options_with_values[j].name == 'metal') {
					for (var k = 0; k < options_with_values[j].values.length; k++) {
						console.log(data.title + ' ' +options_with_values[j].values[k].image + ' ' + options_with_values[j].values[k].title );
					}
				}
			}*/
			var number_color = '';
			var title_color = '';
			itemImagesHtml += '%;*/">';
			for (var i = 0; i < images.length; i++) {
				number_color = '';
				title_color = '';
				for (var j = 0; j < options_with_values.length; j++) {
					if (options_with_values[j].name == 'metal') {
						for (var k = 0; k < options_with_values[j].values.length; k++) {
							//console.log(i + ' === '+ options_with_values[j].values[k].image);
							if (i === options_with_values[j].values[k].image - 1) {
								number_color = i;
								title_color = options_with_values[j].values[k].title;
								//console.log(data.title + ' ' +options_with_values[j].values[k].image + ' ' + options_with_values[j].values[k].title );
							}
						}
					}
				}
				itemImagesHtml += '<div class="grid-view-item__picture" data-image-id="'+ number_color +'" data-image-title="'+ title_color +'">';
				itemImagesHtml += '<img id="' + imgId + '" ' +
					'class="grid-view-item__image 333 lazyload" ' +
					'src="' + Utils.optimizeImage(images[i].src, '533x') + '" ' +
					'data-src="' + Utils.optimizeImage(images[i].src, '{width}x') + '" ' +
					'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
					'data-aspectratio="' + aspect_ratio + '" ' +
					'data-sizes="auto" ' +
					'alt="{{itemTitle}}">';
				itemImagesHtml += '</div>';
			}
			itemImagesHtml += '</div>';
			itemImagesHtml += '</div>';
		}
		var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
		var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
		itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + Utils.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

	
	
	
	
	
	
		// Add Vendor
		var itemVendorHtml = boostPFSTemplate.vendorGridHtml;
		//itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		var metafield_and_vendor = '';
		var class_watch = '';
		if (data.metafields.length > 0 && data.product_type == 'Watch') {
			var timepiece_name = '';
			var timepiece_reference = '';
			if (data.metafields[0] && data.metafields[0].key == 'timepiece_name') {
				timepiece_name = data.metafields[0].value;
			}
			if (data.metafields[1] && data.metafields[1].key == 'timepiece_reference') {
				timepiece_reference = data.metafields[1].value;
			}
			if (timepiece_name != '' && timepiece_reference != '') {
				metafield_and_vendor = '<div class="card__vandor">' + itemVendorHtml + '</div><div class="card__timepiece">' + timepiece_name + '</div><div class="card__reference">' + timepiece_reference + '</div>';
				class_watch = 'card__content--watch';
			}
			//console.log(metafield_and_vendor);
			 
		}
		itemHtml = itemHtml.replace(/{{class_watch}}/g, class_watch);
		itemHtml = itemHtml.replace(/{{metafield_and_vendor}}/g, metafield_and_vendor);

		

		// Add Price
		var itemTemplateHtml = data.template_suffix;
		var itemTags = data.tags;
		var itemTagInquire = itemTags.includes('inquire');
		if (itemTemplateHtml == 'inquire' || itemTemplateHtml == 'inquire-audemars-piguet' || itemTagInquire == true) {
			var itemPriceHtml = '<div data-template="'+itemTemplateHtml+'">INQUIRE</div>'
		} else {
			var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Color Swatches
		itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildProductOptionSwatches(data));


		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}


		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		itemHtml = itemHtml.replace(/\[\[itemTitle\]\]/g, data.title);
		itemHtml = itemHtml.replace(/\[\[itemUrl\]\]/g, Utils.buildProductItemUrl(data));

		/* Swym integration */

		var itemWishlistHtml = '<button aria-label="Add ' + data.title + ' to Wishlist" class="swym-button swym-add-to-wishlist-view-product buttons__collection-wishlist-not-login" data-product-id="' + JSON.stringify(data.id) + '" data-variant-id="' + data.variants[0].id + '" data-variant-title="' + data.variants[0].title + '"  data-variant-price="' + data.variants[0].price + '" data-title="' + data.title + '" data-product-url="' + boostPFSConfig.shop.url + Utils.buildProductItemUrl(data, false) + '"></button> '
		 itemWishlistHtml += '<button  aria-label="Add ' + data.title + ' to Wishlist"  data-with-epi="true" class="buttons__collection-wishlist-logged-in swym-button swym-add-to-wishlist-view-product wishlist swym-button product_' + data.id + '" data-swaction="addToWishlist" data-product-id="' + JSON.stringify(data.id) + '" data-variant-id="' + data.variants[0].id + '" data-product-url="' + boostPFSConfig.shop.url + Utils.buildProductItemUrl(data, false) + '"></button>';
		if (itemTemplateHtml == 'inquire' || itemTemplateHtml == 'inquire-audemars-piguet' || itemTagInquire == true) {
			itemWishlistHtml = '';
		} 
		itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);


		/* Labels */
		var itemLabelsHtml = buildProductLabels(data);
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

		return itemHtml;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	}

	// Build Image style
	function buildImageStyle(data) {
		var images = data.images_info;
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSConfig.custom.max_height;
			var height = boostPFSConfig.custom.max_height;
			var aspect_ratio = image.width / image.height;
			var small_style = true;
			var container_aspect_ratio = width * 1.0 / height;

			if (image.aspect_ratio < 1.0) {
				var maximum_width = height * aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					maximum_width = image.width;
				} else {
					var maximum_height = height;
				}
			} else if (aspect_ratio < container_aspect_ratio) {
				var maximum_height = height / aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					var maximum_width = image.width;
				} else {
					var maximum_height = height;
					var maximum_width = height * aspect_ratio;
				}
			} else {
				var maximum_height = height / aspect_ratio;
				if (image.width <= width) {
					maximum_height = image.height;
					var maximum_width = image.width
				} else {
					var maximum_width = width;
					maximum_height = maximum_width / aspect_ratio;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio < 1) {
					maximum_width = 750 * aspect_ratio;
				} else {
					if (image.width < 750) {
						maximum_width = image.width;
					} else {
						maximum_width = 750;
					}
				}
				imageStyle += '@media screen and (max-width: 749px) {'
				imageStyle += '#' + imgId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'max-height: 750px;' +
					'}' +
					'#' + wrapperId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'}';
				imageStyle += '}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	function buildPrice(data, onSale, priceVaries, product_price) {
		var priceHtml = '',
			onSaleClass = onSale ? ' price--on-sale' : '';
		var soldOutClass = data.available ? '' : ' price--sold-out';
		var comparePriceVaries = data.compare_at_price_min != data.compare_at_price_max;
		var priceVariesClass = !priceVaries && comparePriceVaries ? ' price--compare-price-hidden' : '',
			variant = data.variants[0],
			unitPriceMeasurementClass = '',
			unitPriceSeparatorHtml = '',
			unitPirceBaseUnitHtml = '';

		if (variant.hasOwnProperty('unit_price_measurement')) {
			unitPriceMeasurementClass = ' price--unit-available';
		}

		priceHtml += '<dl class="price price--listing' + onSaleClass + soldOutClass + priceVariesClass + unitPriceMeasurementClass + '" data-price>';
		/*if (boostPFSConfig.custom.hasOwnProperty('vendor_enable') && boostPFSConfig.custom.vendor_enable == true) {
			priceHtml += '<div class="price__vendor price__vendor--listing"><dt>';
			priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.vendor + '</span>';
			priceHtml += '</dt><dd>';
			priceHtml += data.vendor;
			priceHtml += '</dd></div>';
		}*/

		priceHtml += '<div class="price__regular">';
		priceHtml += '<dt><span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
		priceHtml += '</dt><dd>';
		priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
		if(product_price) {
			priceHtml += Utils.formatMoney(product_price);
		} else {
			if (priceVaries) {
				priceHtml += boostPFSConfig.label.from_lowest_price_html.replace(/{{ lowest_price }}/, Utils.formatMoney(data.price_min));
			} else {
				priceHtml += Utils.formatMoney(data.price_min);
			}
		}
		priceHtml += '</span></dd></div>';

		priceHtml += '<div class="price__sale"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.sale_price +
			'</span></dt>';
		priceHtml += '<dd> <span class="price-item price-item--sale">';
		if (priceVaries) {
			priceHtml += boostPFSConfig.label.from_lowest_price_html.replace(/{{ lowest_price }}/, Utils.formatMoney(data.price_min));
		} else {
			priceHtml += Utils.formatMoney(data.price_min);
		}
		priceHtml += '</span></dd>';
		priceHtml += '<div class="price__compare"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.regular_price;
		priceHtml += '</span></dt>';
		priceHtml += '<dd> <s class="price-item price-item--regular">';
		priceHtml += Utils.formatMoney(data.compare_at_price_min);
		priceHtml += '</s></dd></div>';
		priceHtml += '</div>';

		priceHtml += '<div class="price__unit"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.unit_price_label;
		priceHtml += '</span></dt>';
		priceHtml += '<dd class="price-unit-price">';

		unitPriceSeparatorHtml += '<span tabindex="-1" aria-hidden="true">/</span><span class="visually-hidden">';
		unitPriceSeparatorHtml += boostPFSConfig.label.unit_price_separator + '&nbsp;</span>';

		if (variant.hasOwnProperty('unit_price_measurement') && variant.unit_price_measurement) {
			unitPirceBaseUnitHtml += '<span>';
			if (variant.hasOwnProperty('reference_value') && variant.unit_price_measurement.reference_value != 1) {
				unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_value;
			}
			if (variant.hasOwnProperty('reference_unit')) {
				unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_unit;
			}
			unitPirceBaseUnitHtml += '</span>';
		}

		if (variant.hasOwnProperty('unit_price')) {
			priceHtml += '<span>' + Utils.formatMoney(variant.unit_price) + '</span>';
		}

		priceHtml += unitPriceSeparatorHtml + unitPirceBaseUnitHtml;
		priceHtml += '</dd></div>';

		priceHtml += '<div class="price__badges price__badges--listing">' +
			'<span class="price__badge price__badge--sale" tabindex="-1" aria-hidden="true"> <span>';
		priceHtml += boostPFSConfig.label.sale + '</span></span>';
		priceHtml += '<span class="price__badge price__badge--sold-out">' +
			boostPFSConfig.label.sold_out +
			'</span></span></div>';

		priceHtml += '</dl>';

		return priceHtml;
	}

	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// // Build page items
		// var currentPage = boostPFSConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
		// paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);


		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);		



		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {


		if (!data) data = this.data;

		let allTooltipBanners = document.querySelectorAll('.card-grid__item--tooltip-banner.hide');
		let allProductBanners = document.querySelectorAll('.card-grid__item:not(.card-grid__item--tooltip-banner)');
		let productGrid = document.getElementById('main-collection-product-grid');
		let pageCount = (window.location.href).split('page=')[1];

		allTooltipBanners.forEach((tooltipBanner) => {
		let count = 1;
		//let countPlus = tooltipBanner.dataset.bannerposition + 1;
		//let countMinus = tooltipBanner.dataset.bannerposition - 2;
		if (pageCount == undefined) { pageCount = 1 };
		allProductBanners.forEach((productBanner, idx, array) => {
	
			if (tooltipBanner.dataset.bannerposition == count && tooltipBanner.dataset.bannerpage == pageCount) {
			let cloneTooltipBanner = tooltipBanner.cloneNode(true);
			cloneTooltipBanner.setAttribute('id', `${count++}`);
			cloneTooltipBanner.classList.remove('hide');
			productGrid.insertBefore(cloneTooltipBanner, productBanner);
			
				//productBanner.insertAdjacentHTML("afterend", '<div class="plus"></div>');
				//console.log("plus");
			}
			if (idx === (array.length - 1) && tooltipBanner.dataset.bannerposition > count && tooltipBanner.dataset.bannerpage == pageCount) {
			let cloneTooltipBanner = tooltipBanner.cloneNode(true);
			cloneTooltipBanner.setAttribute('id', `${count++}`);
			cloneTooltipBanner.classList.remove('hide');
			productGrid.insertBefore(cloneTooltipBanner, productBanner);
			}
			
			/*if (count == countMinus && tooltipBanner.dataset.bannerpage == pageCount) {
				productBanner.insertAdjacentHTML("afterend", '<div class="minus"></div>');
				console.log("minus");
			}*/

			count++;
		});
		});

		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}
		/** End Swym integration **/
		document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
		
		$('.grid-view-item__image-wrapper .grid-view-item__slider-wrapper').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: false,
			accessibility: false,
			//autoplay: true,
			arrows: true,
			dots: false,
			adaptiveHeight: false,
			prevArrow: '<div class="prev-arrow"><svg class="svg-arrow" width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.12695 16.3481L0.290834 8.51202M8.12695 1.12406L0.663983 8.58703" stroke="black" stroke-opacity="0.88" stroke-width="0.791568"/></svg></div>',
      		nextArrow: '<div class="next-arrow"><svg class="svg-arrow" width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.873047 1.12415L8.70917 8.96027M0.873047 16.3482L8.33602 8.88526" stroke="black" stroke-opacity="0.88" stroke-width="0.791568"/></svg></div>'
		});

		let evnt = new Event("collectionLoad", {bubbles: true}); 
		document.dispatchEvent(evnt);

	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		console.log('data.products.length = '+ data.products.length);
		if (document.getElementById('main-collection-product-grid') !== null) {
			if (data.products.length < 18) {
				document.getElementById("main-collection-product-grid").classList.add("hide-banners");
			} else {
				document.getElementById("main-collection-product-grid").classList.remove("hide-banners");
			}
		}

		let item = '';

		if (boostPFSFilterConfig.general.promo_position == 'inside' || boostPFSFilterConfig.general.promo_position_mob == 'inside' ) {
			if (boostPFSFilterConfig.general.promo_product) {
				item = buildPromoProduct(boostPFSFilterConfig.general.promo_product);
			}
			else if (boostPFSFilterConfig.general.promo_collection) {
				item = buildPromoCollection(boostPFSFilterConfig.general.promo_collection);
			}
			
			if (item) {
				if (data.products && data.products.length > 6) {
					// jQ(item).insertAfter(jQ('.card:nth-of-type(6)'));
					jQ(item).insertAfter(jQ('.card-grid__item:nth-of-type(6)'));
				}
				else {
					jQ('.boost-pfs-filter-products').append(item);
				}
			}
		}

		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
	};

	function buildProductLabels(data) {
		let html = ''
		for (let i = 0; i < data.tags.length; i++) {
		  if (data.tags[i].includes('Sticker|')) {
		    html += `<li class="card__stickers-item" data-tag="${data.tags[i].split('|')[1].toLowerCase()}">${data.tags[i].split('|')[1]}</li>`;
		  }
		}
		if (html != '') {
		  html = `<ul class="card__stickers">${html}</ul>`;
		} 
		return html;
	}


	function buildPromoProduct(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = '';
		var images_mob = '';
		if (boostPFSFilterConfig.general.promo_image) {
			images = JSON.parse(boostPFSFilterConfig.general.promo_image)[0];
		}
		else {
			images = (data.media && data.media.length > 0) ? data.media[0] : data.images;
		}
		if (boostPFSFilterConfig.general.promo_image_mob) {
			images_mob = JSON.parse(boostPFSFilterConfig.general.promo_image_mob)[0];
		}
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		
		var product_price = Math.floor(data.price_min/100);
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add a specific class for grid item
		var itemGridWidthClass = '';
		var imageSize = '600x600';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemGridWidthClass = 'medium-up--one-half';
				imageSize = '540x600';
				break;
			case 3:
				itemGridWidthClass = 'small--one-half medium-up--one-third';
				imageSize = '345x550';
				break;
			case 4:
				itemGridWidthClass = 'small--one-half medium-up--one-quarter';
				imageSize = '250x';
				break;
			case 5:
				itemGridWidthClass = 'small--one-half medium-up--one-fifth';
				imageSize = '195x';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		// Add fullWidth class
		var itemFullWidthClass = boostPFSFilterConfig.general.promo_product ? boostPFSTemplate.fullWidthClass : '';
		itemHtml = itemHtml.replace(/{{itemFullWidthClass}}/g, itemFullWidthClass);


		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;

		// Build Image style
		// var imageStyle = buildImageStyle(data);
		// itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

		// Add Images
		var aspect_ratio = '';
		var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
		itemImagesHtml += '<div style="padding-top:';
		var image_src = '';
		var class_for_desk_image ='';

		if (images || images.length > 0) {
			aspect_ratio = images['width'] / images['height'];
			itemImagesHtml += 1 / aspect_ratio * 100;
			image_src = images['src'];
		} else {
			itemImagesHtml += 100;
			image_src = boostPFSAppConfig.general.no_image_url;
		}
		if (images_mob) {
			aspect_ratio_mob = images['width'] / images['height'];
			image_src_mob = images_mob['src'];
			class_for_desk_image = 'grid-view-item__image--desktop';
		}
		itemImagesHtml += '%;">';
		itemImagesHtml += '<img id="' + imgId + '" ' +
			'class="grid-view-item__image ' + class_for_desk_image + ' lazyload" ' +
			'src="' + image_src + '" ' +
			'data-src="' + image_src + '" ' +
			'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
			'data-aspectratio="' + aspect_ratio + '" ' +
			'data-sizes="auto" ' +
			'alt="{{itemTitle}}">';
		if (images_mob) {
			itemImagesHtml += '<img id="' + imgId + '-mob" ' +
				'class="grid-view-item__image grid-view-item__image--mobile lazyload" ' +
				'src="' + image_src_mob + '" ' +
				'data-src="' + image_src_mob + '" ' +
				'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
				'data-aspectratio="' + aspect_ratio_mob + '" ' +
				'data-sizes="auto" ' +
				'alt="{{itemTitle}}">';
		}
		itemImagesHtml += '</div>';
		itemImagesHtml += '</div>';

		var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
		var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
		itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + image_src + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
		
		
		// Add Price
		
		var itemPriceHtml = buildPrice(data, onSale, priceVaries, product_price);
		console.log(boostPFSFilterConfig.general.product_inquire);
		if (boostPFSFilterConfig.general.product_inquire == 'true') {
			itemPriceHtml = 'INQUIRE';
		} 

		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		itemHtml = itemHtml.replace(/\[\[itemTitle\]\]/g, data.title);
		itemHtml = itemHtml.replace(/\[\[itemUrl\]\]/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	}

	function buildPromoCollection(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = '';
		if (boostPFSFilterConfig.general.promo_image) {
			images = JSON.parse(boostPFSFilterConfig.general.promo_image)[0];
		}
		else {
			images = data.image ? data.image : '';
		}

		if (boostPFSFilterConfig.general.promo_image_mob) {
			images_mob = JSON.parse(boostPFSFilterConfig.general.promo_image_mob)[0];
		}
		/*** End Prepare data ***/

		// Get Template
		// var itemHtml = boostPFSTemplate.productGridItemHtml;
		var itemHtml = boostPFSTemplate.collectionItemHtml;
		// Add a specific class for grid item
		var itemGridWidthClass = '';
		var imageSize = '600x600';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemGridWidthClass = 'medium-up--one-half';
				imageSize = '540x600';
				break;
			case 3:
				itemGridWidthClass = 'small--one-half medium-up--one-third';
				imageSize = '345x550';
				break;
			case 4:
				itemGridWidthClass = 'small--one-half medium-up--one-quarter';
				imageSize = '250x';
				break;
			case 5:
				itemGridWidthClass = 'small--one-half medium-up--one-fifth';
				imageSize = '195x';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add fullWidth class
		var itemFullWidthClass = boostPFSFilterConfig.general.promo_collection ? boostPFSTemplate.fullWidthClass : '';
		itemHtml = itemHtml.replace(/{{itemFullWidthClass}}/g, itemFullWidthClass);

		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;

		// Build Image style
		// var imageStyle = buildImageStyle(data);
		// itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

		// Add Images
		var aspect_ratio = '';
		var image_src = '';
		var class_for_desk_image ='';

		var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
		itemImagesHtml += '<div style="padding-top:';

		if (images) {
			aspect_ratio = images['width'] / images['height'];
			itemImagesHtml += 1 / aspect_ratio * 100;
			image_src = images['src'];
		} else {
			itemImagesHtml += 100;
			image_src = boostPFSAppConfig.general.no_image_url;
		}
		if (images_mob) {
			aspect_ratio_mob = images['width'] / images['height'];
			image_src_mob = images_mob['src'];
			class_for_desk_image = 'grid-view-item__image--desktop';
		}
		itemImagesHtml += '%;">';
		itemImagesHtml += '<img id="' + imgId + '" ' +
			'class="grid-view-item__image ' + class_for_desk_image + ' lazyload" ' +
			'src="' + image_src + '" ' +
			'data-src="' + image_src + '" ' +
			'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
			'data-aspectratio="' + aspect_ratio + '" ' +
			'data-sizes="auto" ' +
			'alt="{{itemTitle}}">';
		if (images_mob) {
			itemImagesHtml += '<img id="' + imgId + '-mob" ' +
				'class="grid-view-item__image grid-view-item__image--mobile lazyload" ' +
				'src="' + image_src_mob + '" ' +
				'data-src="' + image_src_mob + '" ' +
				'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
				'data-aspectratio="' + aspect_ratio_mob + '" ' +
				'data-sizes="auto" ' +
				'alt="{{itemTitle}}">';
		}
		itemImagesHtml += '</div>';
		itemImagesHtml += '</div>';

		var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
		var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
		itemImagesHtml += '<noscript><img class="grid-view-item__image " src="' + image_src + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, '/collections/' + data.handle);

		return itemHtml;
	}

	/* start-boost-custom */
	/* #boost-109602: scroll to top when navigating */
	ProductPaginationDefault.prototype._onClickEvent = function(event) {
		event.preventDefault();
		Globals.internalClick = true;

		// Get the new page value
		var url;
		try {
			url = new URL(jQ(event.currentTarget).attr('href'));
		} catch (e) {
			url = new URL('https://' + boostPFSConfig.shop.domain + jQ(event.currentTarget).attr('href'));
		}

		var pageValue = url && url.searchParams ? url.searchParams.get('page') : 1;
		if (!pageValue || isNaN(pageValue)) pageValue = 1;

		// Apply filter
		FilterApi.setParam('page', pageValue);
		FilterApi.applyFilter('page');

		// Scroll to top of product list
		window.scrollTo({
			top: 0,			
		});
	}
	/* end-boost-custom */


	// Start Boost 157394
	function onlyUnique(value, index, self) {
		return self.indexOf(value) === index;
	  }
	  // Build Color Swatches
	  function buildProductOptionSwatches(data) {
		var swatchesProductOptionHtml = '';
		if (boostPFSThemeConfig.custom.swatch_enable) {
		  var swatchApplyFor = ['color', 'img', 'text']; // 'pro_img'
		  for(var i = 0; i < swatchApplyFor.length; i++){
			var optionNames = boostPFSThemeConfig.custom["swatch_by_" + swatchApplyFor[i] + "_apply"].split(',').filter(onlyUnique);
			var swatchShape = boostPFSThemeConfig.custom["swatch_by_" + swatchApplyFor[i] + "_shape"];
			var swatchType = swatchApplyFor[i];
			// console.log('optionNames', optionNames);
			// console.log('swatchShape', swatchShape);
			// console.log('swatchType', swatchType);
			for(var j=0; j < optionNames.length; j++){
			  var optionName = optionNames[j].trim();
			  var filterSwatchTitle = optionName,
			  swatchArr = [],
			  countSwatch = 0,
			  swatchValues = [],
			  swatchLimit = 4;
			  var indexSlide = 0;
			  // console.log('OPTION NAME:', optionName);
			  // console.log('SWATCH TITLE:', filterSwatchTitle);
		  
			  var dataImgSize = '360',
				bgSize = '50x',
				dataImgSrc = Utils.getFeaturedImage(data.images_info, dataImgSize + 'x'),
				swatchName = '#ffffff',
				bgImageSrc = '',
				viewMoreLabel = 'More ' + filterSwatchTitle;
		
			  if (typeof data.options_with_values != 'undefined' && data.options_with_values.length > 0) {
				swatchArr = data.options_with_values.filter(function(option) {
				  return option.name == optionName;
				});
				// console.log('data.options_with_values', data.options_with_values)
				if (swatchArr.length > 0) {
				  countSwatch = swatchArr[0].values.length;
				  if (swatchLimit > countSwatch) {
					swatchLimit = countSwatch;
				  }
				  swatchValues = swatchArr[0].values;
				 // console.log('Swatch NAME:', swatchValues);

				 if (data.metafields.length > 0) {
					var gallery_color_labels = JSON.parse(data.metafields[0].value);
					swatchesProductOptionHtml += '<div class="boost-pfs-filter-item-swatch-wrapper"><div class="boost-pfs-filter-item-swatch-title">'+ gallery_color_labels[0] +'</div>';
				 } else {
					swatchesProductOptionHtml += '<div class="boost-pfs-filter-item-swatch-wrapper"><div class="boost-pfs-filter-item-swatch-title">'+ swatchValues[0].title +'</div>';
				 }
				swatchesProductOptionHtml += '<ul class="boost-pfs-filter-item-swatch boost-pfs-filter-item-swatch-option-' + optionName + ' boost-pfs-filter-item-swatch-shape-' + swatchShape + ' boost-pfs-filter-item-swatch-type-' + swatchType + '">';
				
				if (data.metafields.length > 0) {
					
					for (var i = 0; i < gallery_color_labels.length; i++) {
						console.log(gallery_color_labels[i]);
							swatchesProductOptionHtml += '<li class="boost-pfs-filter-item-swatch-li">';

							if (i == 0) {
								swatchesProductOptionHtml += '<span class="boost-pfs-filter-item-swatch-span metafield-swatch-span active" tabindex="0" data-swatch="' +  gallery_color_labels[i].toLowerCase() + '" data-title="' +  gallery_color_labels[i] + '"';
							} else {
								swatchesProductOptionHtml += '<span class="boost-pfs-filter-item-swatch-span metafield-swatch-span" tabindex="0" data-swatch="' +  gallery_color_labels[i].toLowerCase() + '" data-title="' +  gallery_color_labels[i] + '"';
							}
							swatchesProductOptionHtml += 'onclick="swatchGallery(this);" ></span>';
							
							swatchesProductOptionHtml += '</li>';
					}

				} else {
				  for (var sIndex = 0; sIndex < swatchLimit; sIndex++) {
					swatchName = swatchValues[sIndex].title;
					swatchVariant = data['variants'][sIndex];
					sImageIndex = swatchValues[sIndex].image || '';
					if (sImageIndex != '') {
					  dataImgSrc = Utils.optimizeImage(data.images[sImageIndex], dataImgSize + 'x') + ' ' + dataImgSize + 'w';
					}
					//console.log('swatchType', swatchType)
					if (swatchType) {
					  switch (swatchType) {
						case 'color':
						  bgImageSrc = boostPFSAppConfig.general.file_url.replace(/\?/, Utils.slugify(swatchName) + '.png?v=');
						  break;
						case 'pro_img':
						  bgImageSrc = Utils.getFeaturedImage(data.images_info, bgSize);
						  if (sImageIndex != '') {
							bgImageSrc = Utils.optimizeImage(data.images[sImageIndex], bgSize);
						  }
						  break;
						default:
						  bgImageSrc = '';
					  }
					}
					swatchesProductOptionHtml += '<li class="boost-pfs-filter-item-swatch-li">';
					  if(swatchType == 'text'){
						swatchesProductOptionHtml += '<a aria-label="' + optionName + ': ' + swatchName + '" title="' + swatchName + '" href="' + Utils.buildProductItemUrl(data) + '?variant=' + swatchVariant.id + '">' + swatchName + '</a>';
					  } else {
						if(boostPFSThemeConfig.custom.show_swatch_tooltip){
						  swatchesProductOptionHtml += '<div class="boost-pfs-product-item-tooltip">' + swatchName + '</div>';
						}
						indexSlide = sImageIndex - 1;
						if (sIndex == 0) {
							swatchesProductOptionHtml += '<span class="boost-pfs-filter-item-swatch-span gallery-swatch-span active" data-slide="'+ indexSlide  +'" tabindex="0" data-swatch="' +  swatchName.toLowerCase() + '" data-title="' +  swatchName + '" aria-label="' + optionName + ': ' + swatchName + '" ' + 'style="background-color: ' + swatchName + '; ';
						} else {
							swatchesProductOptionHtml += '<span class="boost-pfs-filter-item-swatch-span gallery-swatch-span" data-slide="'+ indexSlide +'" tabindex="0" data-swatch="' +  swatchName.toLowerCase() + '" data-title="' +  swatchName + '" aria-label="' + optionName + ': ' + swatchName + '" ' + 'style="background-color: ' + swatchName + '; ';
						}
						if (bgImageSrc != '') {
							//swatchesProductOptionHtml += 'background-image: url(' + bgImageSrc + ');" ';
							swatchesProductOptionHtml += '" ';
						} else {
							swatchesProductOptionHtml += '" ';
						}
						if (dataImgSrc != '') {
							swatchesProductOptionHtml += 'data-img="' + dataImgSrc + '" ';
							swatchesProductOptionHtml += 'onclick="swatchImage(this);" ';
						}
						swatchesProductOptionHtml += '></span>';
					  }
					swatchesProductOptionHtml += '</li>';
				  }
				}


				  if (countSwatch > swatchLimit) {
					swatchesProductOptionHtml += '<li class="boost-pfs-filter-item-swatch-more">';
					swatchesProductOptionHtml += '<a href="{{itemUrl}}" aria-label="' + viewMoreLabel + '" title="' + viewMoreLabel + '">+' + (countSwatch - swatchLimit) + '</a>';
					swatchesProductOptionHtml += '</li>';
				  }
				  swatchesProductOptionHtml += '</ul>';
				  swatchesProductOptionHtml += '</div>';
				}
			  }
			}
			
		  }
		}
		return swatchesProductOptionHtml;
	  }
		// End Boost 157394

	// Product URL on title only; image uses delegated click for pointer users (keyboard: title link)
	if (typeof jQuery !== 'undefined') {
		jQuery(document).on('click', '.boost-pfs-filter-products .card__picture', function (e) {
			if (jQuery(e.target).closest('.slick-arrow, .prev-arrow, .next-arrow, .svg-arrow').length) {
				return;
			}
			var href = jQuery(this).closest('.card').find('.card__title-link').attr('href');
			if (href) {
				window.location.href = href;
			}
		});
	}

})();